/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import LoginCers from "./LoginCers";
import { Logout } from "./modules/Auth";
import Callback from "./modules/Auth/pages/Callback";
import Login from "./modules/Auth/pages/Login";
import TwoFactor from "./modules/Auth/pages/TwoFactor";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import Jusfinder from "./modules/Jusfinder";
import PasswordReset from "./modules/PasswordReset";
import ForgotPassword from "./modules/ForgotPassword";
import Validation from "./modules/Validation";

export function Routes() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null
    }),
    shallowEqual
  );

  // Hydra may land on login_destination root (e.g. /?login_challenge=...).
  // Always keep the query when bouncing unauthorized users to the login page.
  const authLoginRedirect = {
    pathname: "/auth/login",
    search: window.location.search
  };

  return (
    <Switch>
      {(window.location.hostname == "jusfinder.com.br" ||
        window.location.hostname == "www.jusfinder.com.br") && (
        <Route exact path="/" component={Jusfinder} />
      )}
      <Route path="/auth/cers/:email/:nome" component={LoginCers} />
      {isAuthorized ? (
        <Redirect exact from="/callback" to="/" />
      ) : null}
      <Route path="/callback" component={Callback} />
      <Route path="/forgot_password" component={ForgotPassword} />
      <Route path="/password_reset/:token" component={PasswordReset} />

      <Route path="/validation/:token" component={Validation} />
      <Route path="/jusfinder" component={Jusfinder} />
      <Route path="/logout" component={Logout} />
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <Switch>
            <ContentRoute path="/auth/login" component={Login} />
            <ContentRoute path="/auth/two-factor" component={TwoFactor} />
            <Redirect from="/auth" exact={true} to={authLoginRedirect} />
            <Redirect to={authLoginRedirect} />
          </Switch>
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to={authLoginRedirect} />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
    </Switch>
  );
}
